<template>
  <!-- BEGIN: Top Bar -->
  <div class="top-bar pl-1 sm:pl-3 xl:pl-2">
    <div
      v-if="!isMobile"
      class="flex flex-row semixs:flex-col justify-start pl-3 lg:pl-5 gap-1"
    >
      <div class="flex items-center gap-2">
        <svg
          viewBox="0 0 40 32"
          class="hidden lg:block lg:h-6 xl:h-7 fill-current text-theme-43"
        >
          <path
            d="M34.25 5.127h-4.362v-0.289c0-2.667-2.171-4.838-4.838-4.838h-10.66c-2.667 0-4.838 2.171-4.838 4.838v0.289h-4.159c-2.974-0.001-5.393 2.419-5.393 5.393v16.088c0 2.971 2.419 5.391 5.393 5.391h28.857c2.971 0 5.391-2.419 5.391-5.391v-16.088c0-2.974-2.419-5.393-5.391-5.393zM13.096 4.838c0-0.712 0.582-1.293 1.293-1.293h10.66c0.714 0 1.293 0.582 1.293 1.293v22.123c0 0.714-0.579 1.293-1.293 1.293h-2.426v-3.268c0-1.562-1.266-2.828-2.828-2.828s-2.828 1.266-2.828 2.828v3.268h-2.578c-0.712 0-1.293-0.579-1.293-1.293v-22.122zM5.393 28.455c-1.019 0-1.849-0.827-1.849-1.846v-5.195h2.593c0.989 0 1.793-0.804 1.793-1.793s-0.804-1.796-1.793-1.796h-2.593v-2.242h2.593c0.989 0 1.793-0.806 1.793-1.796s-0.804-1.793-1.793-1.793h-2.593v-1.474c0-1.019 0.83-1.849 1.849-1.849h4.159v18.29c0 0.523 0.083 1.025 0.239 1.494h-4.398zM34.25 28.455h-4.599c0.153-0.47 0.236-0.971 0.236-1.494v-18.288h4.362c1.019 0 1.846 0.83 1.846 1.849v1.474h-2.591c-0.989 0-1.796 0.804-1.796 1.793s0.806 1.796 1.796 1.796h2.591v2.242h-2.591c-0.989 0-1.796 0.806-1.796 1.796s0.806 1.793 1.796 1.793h2.591v5.195c0 1.019-0.827 1.846-1.846 1.846z"
          ></path>
          <path
            d="M17.006 10.659h1.395v1.395c0 0.52 0.422 0.943 0.943 0.943h0.943c0.52 0 0.943-0.422 0.943-0.943v-1.395h1.395c0.52 0 0.943-0.422 0.943-0.943v-0.943c0-0.52-0.422-0.943-0.943-0.943h-1.395v-1.395c0-0.52-0.422-0.943-0.943-0.943h-0.943c-0.52 0-0.943 0.422-0.943 0.943v1.395h-1.395c-0.52 0-0.943 0.422-0.943 0.943v0.943c0 0.52 0.422 0.943 0.943 0.943z"
          ></path>
        </svg>

        <!-- <div class="flex flex-col gap-0.5"> -->
        <!-- <div class="flex gap-1 items-center mt-0 md:mt-2">
            <h2 class="nunito font-black text-theme-43 text-base lg:text-xl">
              {{
                typeof user == 'object' && user
                  ? user.name
                    ? user.name
                    : user.first_name + ' ' + user.last_name
                  : user
              }}
            </h2>
            <div class="nunito text-theme-43">-</div>
            <h2 class="nunito font-black text-theme-43 text-base lg:text-xl">
              {{ typeof user == 'object' && user ? user.role.name : '' }}
            </h2>
          </div> -->
        <h2
          class="text-xs md:text-base lg:text-lg font-bold nunito text-theme-43 mt-2 text-center lg:text-left"
        >
          {{ clinicName ? clinicName : clinic }}
        </h2>
        <!-- </div> -->
      </div>
    </div>
    <!-- start search results -->

    <div
      v-if="isActiveSearch === true"
      class="search-result top-24"
      style="visibility: visible; opacity: 1"
    >
      <div class="">
        <div class="search-result__content justify-between">
          <div class="closing-btn top-10">
            <XIcon class="cursor-pointer" @click="closeDropDownSearch" />
          </div>
          <!--search customers-->
          <div class="w-full mb-5 mt-5 lg:mt-10">
            <div class="flex justify-center mr-5">
              <div class="h-8 w-8 bg-theme-40 p-2 rounded-full mr-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  class="text-white fill-current"
                >
                  <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                  <path
                    d="M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304z"
                  />
                </svg>
              </div>
              <div class="search-result__content__title md:text-sm">
                Clienti
              </div>
            </div>
            <div class="flex justify-center">
              <Paginator
                v-show="filteredCustomer != ''"
                :for-page-option="pagination_customer.forPage"
                :total-records="totalRecordsCustomer"
                @changePagination="changePaginationCustomer"
              />
            </div>
            <div class="mb-5">
              <!--no history research-->
              <div
                v-if="filteredCustomer === ''"
                class="text-center font-lg mt-4"
              >
                Nessuna ricerca effettuata di recente
              </div>
              <!--no item found -->
              <div
                v-else-if="filteredCustomer.length === 0"
                class="text-center font-lg mt-4"
              >
                Nessun cliente trovato durante la ricerca
              </div>
              <ul>
                <li
                  v-for="elem in filteredCustomer"
                  :key="elem.id"
                  class="search-result_list"
                  @click.stop="$goToCustomer(elem)"
                >
                  <div class="flex">
                    <div class="w-3/5 border-r-2 border-theme-45">
                      <div class="w-full flex flex-col justify-between">
                        <span
                          class="pt-3 text-lg font-nunito text-theme-40 font-bold ml-5"
                          >{{
                            elem.ragione_sociale
                              ? elem.ragione_sociale
                              : elem.first_name + ' ' + elem.last_name
                          }}</span
                        >
                        <div class="mt-1 ml-4 mb-4">
                          <div class="flex items-center gap-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 256 512"
                              class="h-4 w-4 text-theme-41 fill-current"
                            >
                              <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                              <path
                                d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z"
                              />
                            </svg>
                            <div class="text-gray-500 flex gap-1 items-center">
                              <span>{{ elem.address.address }}, </span>
                              <span>
                                {{ elem.address.house_number }}
                              </span>
                            </div>

                            <div class="text-gray-500 flex gap-1 items-center">
                              <span>{{ elem.address.city }},</span>
                              <span> {{ elem.address.region }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- pet details -->

                    <div class="w-2/6 ml-3">
                      <ul class="flex flex-col ml-3">
                        <li
                          v-for="(pet, k) in elem.pets"
                          :key="pet"
                          class="mt-2 mb-1 md:mt-5"
                        >
                          <div class="flex pr-2 mb-1">
                            <div class="flex">
                              <svg
                                v-if="!pet.alive"
                                viewBox="0 0 27 32"
                                class="text-theme-43 h-4 w-4 fill-current mr-2"
                              >
                                <path
                                  d="M25.451 28.297h-23.6c-1.023 0-1.851 0.83-1.851 1.851s0.83 1.851 1.851 1.851h23.6c1.023 0 1.851-0.83 1.851-1.851s-0.83-1.851-1.851-1.851z"
                                ></path>
                                <path
                                  d="M25.423 11.082c0-6.12-4.961-11.082-11.082-11.082-6.883 0-12.463 5.58-12.463 12.463v13.734h23.545v-15.116zM17.774 10.41h-2.64v7.507c0 0.818-0.664 1.482-1.482 1.482s-1.482-0.664-1.482-1.482v-7.507h-2.64c-0.818 0-1.482-0.664-1.482-1.482s0.664-1.482 1.482-1.482h2.64v-2.534c0-0.818 0.664-1.482 1.482-1.482s1.482 0.664 1.482 1.482v2.534h2.64c0.818 0 1.482 0.664 1.482 1.482s-0.664 1.482-1.482 1.482z"
                                ></path>
                              </svg>
                              <svg
                                v-else
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                class="text-theme-43 h-4 w-4 fill-current mr-2"
                              >
                                <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                                <path
                                  d="M256 224c-79.37 0-191.1 122.7-191.1 200.2C64.02 459.1 90.76 480 135.8 480C184.6 480 216.9 454.9 256 454.9C295.5 454.9 327.9 480 376.2 480c44.1 0 71.74-20.88 71.74-55.75C447.1 346.8 335.4 224 256 224zM108.8 211.4c-10.37-34.62-42.5-57.12-71.62-50.12S-7.104 202 3.27 236.6C13.64 271.3 45.77 293.8 74.89 286.8S119.1 246 108.8 211.4zM193.5 190.6c30.87-8.125 46.37-49.1 34.5-93.37s-46.5-71.1-77.49-63.87c-30.87 8.125-46.37 49.1-34.5 93.37C127.9 170.1 162.5 198.8 193.5 190.6zM474.9 161.3c-29.12-6.1-61.25 15.5-71.62 50.12c-10.37 34.63 4.75 68.37 33.87 75.37c29.12 6.1 61.12-15.5 71.62-50.12C519.1 202 503.1 168.3 474.9 161.3zM318.5 190.6c30.1 8.125 65.62-20.5 77.49-63.87c11.87-43.37-3.625-85.25-34.5-93.37c-30.1-8.125-65.62 20.5-77.49 63.87C272.1 140.6 287.6 182.5 318.5 190.6z"
                                />
                              </svg>
                              <span
                                v-if="
                                  elem.pets.length < 10 ||
                                  (k < elem.pets.length - 1 &&
                                    elem.pets.length >= 10)
                                "
                                class="font-medium"
                                >{{ pet.name }}
                              </span>
                              <span v-else class="font-medium">Altri... </span>
                            </div>

                            <span
                              v-if="
                                elem.pets.length < 10 ||
                                (k < elem.pets.length - 1 &&
                                  elem.pets.length >= 10)
                              "
                              class="pr-5 ml-2 text-gray-600"
                            >
                              ({{ pet.type }})</span
                            >
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
              <!-- <div
                  v-if="filteredCustomer.length > 6"
                  class="w-full text-center"
                >
                  <button
                    class="p-2 mt-4 border rounded border-gray-600 mx-auto hover:-200"
                  >
                    Vedi tutti
                  </button>
                </div> -->
            </div>
          </div>

          <!--search pets-->

          <div class="w-full mt-5 lg:mt-10">
            <div class="flex justify-center">
              <div class="h-8 w-8 bg-theme-40 p-1.5 rounded-full mr-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  class="text-white fill-current"
                >
                  <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                  <path
                    d="M256 224c-79.37 0-191.1 122.7-191.1 200.2C64.02 459.1 90.76 480 135.8 480C184.6 480 216.9 454.9 256 454.9C295.5 454.9 327.9 480 376.2 480c44.1 0 71.74-20.88 71.74-55.75C447.1 346.8 335.4 224 256 224zM108.8 211.4c-10.37-34.62-42.5-57.12-71.62-50.12S-7.104 202 3.27 236.6C13.64 271.3 45.77 293.8 74.89 286.8S119.1 246 108.8 211.4zM193.5 190.6c30.87-8.125 46.37-49.1 34.5-93.37s-46.5-71.1-77.49-63.87c-30.87 8.125-46.37 49.1-34.5 93.37C127.9 170.1 162.5 198.8 193.5 190.6zM474.9 161.3c-29.12-6.1-61.25 15.5-71.62 50.12c-10.37 34.63 4.75 68.37 33.87 75.37c29.12 6.1 61.12-15.5 71.62-50.12C519.1 202 503.1 168.3 474.9 161.3zM318.5 190.6c30.1 8.125 65.62-20.5 77.49-63.87c11.87-43.37-3.625-85.25-34.5-93.37c-30.1-8.125-65.62 20.5-77.49 63.87C272.1 140.6 287.6 182.5 318.5 190.6z"
                  />
                </svg>
              </div>
              <div class="search-result__content__title">Animali</div>
            </div>
            <div class="flex justify-center">
              <Paginator
                v-show="filteredPet != ''"
                :for-page-option="pagination_pet.forPage"
                :total-records="totalRecordsPet"
                @changePagination="changePaginationPet"
              />
            </div>
            <div class="mb-5 n-500">
              <!--no history research-->
              <div v-if="filteredPet === ''" class="text-center font-lg mt-4">
                Nessuna ricerca effettuata di recente
              </div>
              <!--no item found -->
              <div
                v-else-if="filteredPet.length === 0"
                class="text-center font-lg mt-4"
              >
                Nessun animale trovato durante la ricerca
              </div>
              <ul>
                <li
                  v-for="elem in filteredPet"
                  :key="elem.id"
                  class="search-result_list"
                  @click.stop="$goToPet(elem)"
                >
                  <div class="flex flex-col md:flex-row">
                    <div class="w-full md:w-3/5 md:border-r-2 border-theme-45">
                      <div
                        class="w-full flex flex-row items-baseline mt-2 md:flex-col md:justify-between"
                      >
                        <span
                          class="text-lg font-nunito text-theme-40 font-bold ml-5 flex items-center"
                          >{{ elem.name }}

                          <svg
                            v-if="!elem.alive"
                            viewBox="0 0 27 32"
                            class="text-theme-43 h-4 w-4 fill-current ml-2"
                          >
                            <path
                              d="M25.451 28.297h-23.6c-1.023 0-1.851 0.83-1.851 1.851s0.83 1.851 1.851 1.851h23.6c1.023 0 1.851-0.83 1.851-1.851s-0.83-1.851-1.851-1.851z"
                            ></path>
                            <path
                              d="M25.423 11.082c0-6.12-4.961-11.082-11.082-11.082-6.883 0-12.463 5.58-12.463 12.463v13.734h23.545v-15.116zM17.774 10.41h-2.64v7.507c0 0.818-0.664 1.482-1.482 1.482s-1.482-0.664-1.482-1.482v-7.507h-2.64c-0.818 0-1.482-0.664-1.482-1.482s0.664-1.482 1.482-1.482h2.64v-2.534c0-0.818 0.664-1.482 1.482-1.482s1.482 0.664 1.482 1.482v2.534h2.64c0.818 0 1.482 0.664 1.482 1.482s-0.664 1.482-1.482 1.482z"
                            ></path>
                          </svg>
                        </span>

                        <div class="mt-1 ml-2 md:ml-6 md:mb-4">
                          <div class="flex">
                            <span class="text-gray-500 md:mb-4">
                              ({{ elem.type }})
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- owner details -->

                    <div class="w-full ml-3">
                      <div class="flex flex-col ml-2">
                        <div
                          v-for="owner in elem.owners"
                          :key="owner"
                          class="mt-2 md:mt-5"
                        >
                          <div class="flex flex-col mb-1">
                            <div class="flex">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 448 512"
                                class="text-theme-43 h-4 w-4 fill-current mr-2"
                              >
                                <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                                <path
                                  d="M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304z"
                                />
                              </svg>

                              <span class="font-medium">{{
                                owner.ragione_sociale
                                  ? owner.ragione_sociale
                                  : owner.first_name + ' ' + owner.last_name
                              }}</span>
                            </div>
                            <div class="flex items-center mt-1 gap-1">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 256 512"
                                class="h-4 w-4 text-theme-41 fill-current"
                              >
                                <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                                <path
                                  d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z"
                                />
                              </svg>

                              <div
                                class="text-gray-500 flex gap-1 items-center"
                              >
                                <span>{{ owner.address.address }}, </span>
                                <span>
                                  {{ owner.address.house_number }}
                                </span>
                              </div>

                              <div
                                class="text-gray-500 flex gap-1 items-center"
                              >
                                <span>{{ owner.address.city }},</span>
                                <span> {{ owner.address.region }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- end search result -->

    <!-- BEGIN: Breadcrumb -->
    <!-- <div class="-intro-x breadcrumb mr-auto hidden sm:flex">
        <router-link v-for="(elem, elemKey) in crumbs" :key="elemKey" :to="{ name: elem.pageName }">
            {{elem.title}}
            <ChevronRightIcon class="breadcrumb__icon" />
        </router-link>
    </div>-->
    <!-- <BreadCrumbs /> -->

    <!-- END: Breadcrumb -->
    <!-- Start flex row top-bar -->

    <div
      id="input-row"
      class="flex items-center gap-3"
      :class="[isMobile ? 'justify-between w-full' : 'justify-end w-auto']"
    >
      <!-- BEGIN: Search -->

      <div class="flex items-center gap-2">
        <div class="sm:flex-row items-center">
          <NotificationComponent />
        </div>
        <div
          v-if="searchInput"
          class="flex-0 zoom-in cursor-pointer"
          @click="showSearch"
        >
          <i class="fa fa-angle-double-right text-2xl"></i>
        </div>

        <div
          autocomplete="off"
          class="w-full relative"
          :class="{
            flex: !isMobile || (isMobile && searchInput),
            hidden: isMobile && !searchInput
          }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 106.9 56.7"
            class="text-theme-44 fill-current w-11 absolute top-1 left-6"
          >
            <path
              d="M67.4 4.9C77-2.4 90.7-1.4 99.5 7.1s9.8 22 2.5 32.5c-5.8 8.2-20.4 14.8-34.9 5.1-3.4 3.4-6.7 6.8-10.1 10.2-2.1 2.1-4 2.4-5.6.9-1.7-1.6-1.4-3.6.7-5.8l1.1-1.1c3.1-3 6.1-6 9.1-9-9.1-13.6-4.4-27.8 5.1-35ZM100 24.7C100 15.1 91.8 7 82.1 7c-9.9 0-17.8 8-17.8 18.1 0 9.8 8 17.6 17.9 17.6 9.9 0 17.8-7.9 17.8-18Z"
            />
            <rect y="6.3" width="56.5" height="6.6" rx="3.3" ry="3.3" />
            <rect
              x="9.6"
              y="17.3"
              width="41.9"
              height="6.6"
              rx="3.3"
              ry="3.3"
            />
            <rect
              x="23.8"
              y="28.3"
              width="29.4"
              height="6.6"
              rx="3.3"
              ry="3.3"
            />
          </svg>

          <input
            id="search-input"
            v-model="searchBar"
            autocomplete="off"
            type="text"
            class="custom-input w-72 semixxs:w-80 rounded-full p-1.5 pl-20"
            placeholder="Ricerca rapida nell'anagrafica"
            @click.stop="dropDownSearch"
            @keydown="isActiveSearch = true"
            @keydown.esc="closeDropDownSearch"
            @input="
              (event) => $h.debounce(() => searchData(['customer', 'pet']))
            "
          />
        </div>
        <!-- </div> -->

        <!-- search result  -->
      </div>
      <!-- END: Search -->

      <div
        v-if="!searchInput"
        class="flex flex-col-reverse gap-1 mt-2 sm:mt-0 sm:flex-row sm:gap-3 items-center justify-between"
        :class="[isMobile ? 'w-full' : 'w-auto']"
      >
        <h2
          v-if="isMobile"
          class="text-xs md:text-sm lg:text-lg font-bold nunito text-theme-43 text-center lg:text-left"
        >
          {{ clinicName ? clinicName : clinic }}
        </h2>

        <!-- quick search icon -->
        <div class="flex gap-1 items-center">
          <div
            id="clock-icon"
            class="h-5 w-5 mr-8 mb-1 cursor-pointer semilg:hidden zoom-in"
            @click="showSearch"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 106.9 56.7"
              class="text-theme-43 fill-current w-12"
            >
              <path
                d="M67.4 4.9C77-2.4 90.7-1.4 99.5 7.1s9.8 22 2.5 32.5c-5.8 8.2-20.4 14.8-34.9 5.1-3.4 3.4-6.7 6.8-10.1 10.2-2.1 2.1-4 2.4-5.6.9-1.7-1.6-1.4-3.6.7-5.8l1.1-1.1c3.1-3 6.1-6 9.1-9-9.1-13.6-4.4-27.8 5.1-35ZM100 24.7C100 15.1 91.8 7 82.1 7c-9.9 0-17.8 8-17.8 18.1 0 9.8 8 17.6 17.9 17.6 9.9 0 17.8-7.9 17.8-18Z"
              />
              <rect y="6.3" width="56.5" height="6.6" rx="3.3" ry="3.3" />
              <rect
                x="9.6"
                y="17.3"
                width="41.9"
                height="6.6"
                rx="3.3"
                ry="3.3"
              />
              <rect
                x="23.8"
                y="28.3"
                width="29.4"
                height="6.6"
                rx="3.3"
                ry="3.3"
              />
            </svg>
          </div>
          <!--
                   START: advance search  -->

          <div class="mx-1.5 cursor-pointer tooltipbutton">
            <span class="tooltipbuttontext ml-3">Ricerca Avanzata</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 54.3 54.4"
              class="text-theme-43 fill-current w-6 cursor-pointer"
              @click="toggleModal"
            >
              <path
                d="M16.4 4.7c9.2-7 22.3-6.1 30.8 2.1 8.4 8.1 9.4 21.1 2.4 31.1-5.5 7.9-19.5 14.2-33.5 4.9-3.2 3.2-6.5 6.5-9.7 9.8-2 2-3.8 2.3-5.4.8-1.6-1.5-1.4-3.4.7-5.6.3-.4.7-.7 1.1-1.1 2.9-2.9 5.9-5.8 8.7-8.6-8.7-12.9-4.1-26.5 4.9-33.4Zm31.2 19c0-9.2-7.8-17-17.2-17-9.5 0-17 7.7-17 17.3 0 9.4 7.6 16.9 17.2 16.9 9.5 0 17-7.6 17.1-17.3Z"
              />
            </svg>

            <!-- <SearchIcon class="h-7 w-7 text-theme-43" @click="toggleModal" /> -->
            <div v-if="openModalAdvSearch">
              <RicercaAvanzata
                modal-adv-search-title="Ricerca avanzata"
                @close="toggleModal"
                @openConfirmModal="toggleConfirm"
              />
            </div>
          </div>

          <!-- END: Advance search  -->
          <!-- BEGIN: New Client -->
          <div v-if="newClient">
            <NewClient
              :title="'Aggiungi un nuovo cliente'"
              :client="clientData"
              @close="closeNewClientModal"
              @addPaziente="openPet"
            />
          </div>

          <div v-if="newPet">
            <NewPet
              :title="'Aggiungi un nuovo paziente'"
              :client="clientData"
              :pet="petData"
              @close="closeNewPet"
              @back="(el, el2) => openNewClient(el, el2)"
              @referente="openReferente"
            />
          </div>
          <div v-if="newReferent">
            <NewReferente :title="'referente'" @close="newReferent = false" />
          </div>
          <div
            v-if="
              permissions &&
              permissions?.clienti?.store_customer?.enabled === true
            "
            class="mx-1.5 cursor-pointer tooltipbutton"
            @click="openNewClient"
          >
            <span class="tooltipbuttontext ml-5">Aggiungi Cliente</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 75.5 70.9"
              class="text-theme-43 fill-current w-7"
            >
              <path
                d="M30.2 30.7c3.3 0 6.3-1.2 8.5-3.4s3.4-5.2 3.4-8.5c.1-3.1-1-6.1-3.1-8.4-1.6-1.7-4.3-3.6-8.8-3.7H30c-3.1 0-6 1.2-8.1 3.3-2.3 2.3-3.6 5.4-3.6 8.8 0 6.6 5.2 11.8 11.9 11.8Zm10.5 13.4h-.4c-.8-.1-1.6-.3-2.3-.4-.6 0-1.1 0-1.7-.1-4.6-.4-9.3-.2-13.8.2-8.6.6-15.4 7.7-15.7 16.5 0 .7 0 1.1.1 1.2.1 0 .5.2 1.2.2h30.7c-.6-2.1-1-4.3-1-6.5 0-3.9 1-7.7 3-11Z"
                style="fill: none"
              />
              <path
                d="M32.7 61.6H8c-.7 0-1-.1-1.2-.2 0-.1-.2-.5-.1-1.2.3-8.8 7.1-15.9 15.7-16.5 4.5-.3 9.1-.6 13.8-.2.6 0 1.1.1 1.7.2.8 0 1.6.2 2.3.4h.4c1-1.6 2.1-3.2 3.5-4.6s.8-.8 1.3-1.2c-1.4-.5-2.9-.9-4.4-1.2-1.7-.3-3.4-.5-5.1-.6 2.9-.9 5.6-2.4 7.7-4.6 3.5-3.5 5.4-8.1 5.4-13.1.2-4.8-1.6-9.6-4.9-13.1C40.5 2.1 35.7 0 30.3 0c-5 0-9.6 1.8-13.1 5.2-3.6 3.6-5.6 8.4-5.6 13.6 0 8.6 5.6 15.6 13.4 17.9-1 0-2 .1-3 .2C9.9 37.8.5 47.7 0 60c0 2.6.6 4.7 2 6.2s3.5 2.2 6 2.2h26.6v-.3s.1.2.2.3H42c-1.5-2.1-2.7-4.3-3.5-6.8h-6ZM18.4 18.9c0-3.4 1.3-6.5 3.6-8.8 2.1-2.1 5-3.3 8.1-3.3h.2c4.5 0 7.3 2 8.8 3.7 2.1 2.2 3.2 5.2 3.1 8.2 0 3.4-1.2 6.4-3.4 8.6-2.2 2.2-5.2 3.4-8.5 3.4-6.6 0-11.8-5.2-11.9-11.8Z"
              />
              <path
                d="M75.1 53.4c-.9-1.9-2.6-2.1-4.3-2.2h-7.2v-7.9c-.1-2.5-1.7-4-3.9-4-2.1 0-3.5 1.5-3.7 4-.1 2-.1 4 0 6 0 1.4-.4 2-1.9 1.9-1.8-.1-3.6 0-5.3 0-3.2.1-4.7 1.5-4.7 3.9 0 2.5 1.7 3.9 4.8 4 1.7 0 3.4.1 5.1 0 1.6-.1 2.1.5 2 2.1v6.2c.2 2.2 1.5 3.5 3.5 3.6 2.4.1 3.9-1.4 4-4v-7.8h7.8c3.3-.2 5.1-2.9 3.8-5.7Z"
              />
            </svg>

            <!-- <UserPlusIcon class="text-theme-43 h-7 w-7" @click="openNewClient" /> -->
          </div>

          <!-- END: New Client -->

          <!-- BEGIN: Notifications -->
          <div class="dropdown mx-1.5 cursor-pointer">
            <div
              class="mt-1 mr-1 -ml-1 dropdown-toggle cursor-pointer relative tooltipbutton"
              role="button"
              aria-expanded="false"
              @click="getNotifications()"
            >
              <span class="tooltipbuttontext ml-3">Notifiche</span>
              <div v-if="totalBell" id="notification-on" class="notification">
                <span class="notification-number">{{ totalBell }}</span>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 68.4 73.5"
                class="w-6 fill-current text-theme-43"
              >
                <path
                  d="M68.4 17.8c0-1.2-.3-2.5-.6-3.7-.3-1.2-.7-2.4-1.3-3.5-.5-1.1-1.2-2.2-1.9-3.2S63 5.5 62.1 4.6c-.9-.9-1.9-1.7-3.1-2.5-.7-.4-1.3-.7-2-1-.8-.3-1.5-.4-2.1-.3-1.4.2-2.5 1.4-2.6 2.8 0 1.1.4 2.2 1.4 3 .5.5 1.1.8 1.7 1.2.2.1.4.3.7.4 3.1 2 5.2 5.6 5.6 9.6v.3c.1.8.2 1.7.7 2.5.5.8 1.4 1.4 2.4 1.5h.5c1.2 0 2.3-.9 2.7-2 .3-.8.3-1.6.3-2.4Zm-11.7-16Zm-53 20.3H4c1.6-.3 2.7-1.7 2.7-3.2 0-3 1.1-8.6 7.6-11.9 1.5-.8 2.2-2.6 1.6-4.1-.3-.9-1-1.6-1.9-2-.9-.3-1.9-.3-2.7.1C1 6.3 0 16 0 18.8c0 1 .4 1.9 1.2 2.6.6.5 1.3.8 2.1.8h.4ZM61.5 40c-1-4.3-2.1-8.7-3.1-13.1-1.8-8-6.6-14.6-13.1-18.1-2.4-1.3-5.1-2.2-8.1-2.6V4.5c0-2.5-2-4.5-4.5-4.5s-4.5 2-4.5 4.5v1.8c-6.4.9-10.9 3.2-14.6 7.2-2.5 2.8-4.3 6.2-5.5 10.1C6 30.9 4.2 38.4 2.5 45.7c-.4 1.6-.8 3.3-1.2 4.9-.7 3.2-.2 6.1 1.4 8.3 1.7 2.2 4.5 3.5 7.8 3.7 3 .1 6.1.2 9.6.3.3 2.3 1.3 4.4 2.9 6.2 2.2 2.5 5.2 4 8.6 4.3h1.1c3.1 0 6.2-1.1 8.5-3.2 2.1-1.9 3.5-4.4 3.9-7.1 2.7 0 4.9 0 7.2-.1 3.4-.2 7.5-.8 9.8-4 2.1-2.8 1.8-6.4 1.3-9-.8-3.4-1.6-6.8-2.4-10.1Zm-4.9 14.7c-.4.5-1.3.8-2.6.8H11.8c-1.4 0-2.3-.3-2.7-.8-.4-.5-.5-1.5-.1-2.8.6-2.3 1.1-4.6 1.6-6.9 1.2-5.3 2.4-10.7 4.1-15.9l.4-1.2c1.1-3.5 2.4-7.5 4.7-10.2 1.9-2.2 4.5-3.8 8.1-4.6 1.6-.4 3.1-.6 4.6-.6 8.5 0 16.2 5.6 18.4 14.1 1.7 6.5 3.2 13.1 4.6 19.5.4 2 .9 3.9 1.3 5.9.3 1.4.2 2.3-.2 2.9Zm-17.3 8.4c-.9 2.7-3.7 4.5-6.8 4.2-1.8-.2-3.4-1-4.5-2.2-.5-.6-1-1.3-1.2-2.1h12.5Z"
                />
              </svg>
            </div>
            <div class="notification-content pt-2 dropdown-menu">
              <div
                class="notification-content__box dropdown-menu__content box bg-theme-44 bg-opacity-80 rounded-b-xl"
              >
                <div class="bg-white rounded-lg p-1 pb-4">
                  <div class="nunito text-theme-40 text-lg p-2">Notifiche</div>

                  <div
                    ref="notif_container"
                    class="flex flex-col gap-1.5 overflow-auto scrollbar-none px-2"
                    style="max-height: 21.5rem"
                  >
                    <div
                      v-for="(notify, index) in reversedNotifications"
                      :key="notify.id"
                      class="cursor-pointer relative border border-theme-44 rounded-full py-1 pl-2 pr-4"
                      :class="[index % 2 === 0 ? 'bg-white' : 'bg-theme-45']"
                      @click="goToDashBoard"
                    >
                      <div class="overflow-hidden w-full px-3">
                        <div class="flex items-center gap-1">
                          <div class="">
                            <svg
                              v-if="notify.state == 'New'"
                              id="icon-bellC"
                              viewBox="0 0 27 32"
                              class="fill-current w-4 h-4 text-theme-41"
                            >
                              <path
                                d="M0.698 9.104s0.005 0 0.007 0l-0.136 0.025 0.13-0.023z"
                              ></path>
                              <path
                                d="M24.662 11.682c-0.725-3.251-2.682-6.217-5.653-7.813-1.207-0.65-2.528-1.016-3.878-1.157 0.077-0.186 0.118-0.391 0.118-0.607v-0.496c0-0.889-0.721-1.609-1.609-1.609s-1.609 0.721-1.609 1.609v0.496c0 0.225 0.045 0.439 0.13 0.632-0.116 0.014-0.234 0.027-0.35 0.043-2.546 0.357-4.603 1.164-6.335 3.103-1.114 1.25-1.882 2.773-2.348 4.376-1.159 3.958-2.044 7.995-2.987 12.007-0.636 2.712 0.962 4.767 3.753 4.883 1.525 0.064 3.051 0.109 4.581 0.141 0.089 1.062 0.518 2.069 1.248 2.901 0.909 1.034 2.18 1.673 3.576 1.791 0.157 0.011 0.311 0.020 0.466 0.020 1.35 0 2.598-0.502 3.539-1.334 0.923-0.821 1.548-1.959 1.675-3.26 1.178 0.018 2.353 0.023 3.521-0.050 1.457-0.086 3.167-0.364 4.092-1.623 0.777-1.055 0.78-2.464 0.496-3.692-0.793-3.458-1.653-6.899-2.426-10.361z"
                              ></path>
                            </svg>
                            <svg
                              v-else
                              id="icon-bellline"
                              viewBox="0 0 28 32 "
                              class="fill-current w-4 h-4 text-theme-41"
                            >
                              <path
                                d="M27.924 9.127l-0.136-0.025s0.005 0 0.007 0l0.13 0.023z"
                              ></path>
                              <path
                                d="M0.698 9.104s0.005 0 0.007 0l-0.136 0.025 0.13-0.023z"
                              ></path>
                              <path
                                d="M24.662 11.682c-0.725-3.251-2.682-6.217-5.653-7.813-1.207-0.65-2.528-1.016-3.878-1.157 0.077-0.186 0.118-0.391 0.118-0.607v-0.496c0-0.889-0.721-1.609-1.609-1.609s-1.609 0.721-1.609 1.609v0.496c0 0.225 0.045 0.439 0.13 0.632-0.116 0.014-0.234 0.027-0.35 0.043-2.546 0.357-4.603 1.164-6.335 3.103-1.114 1.25-1.882 2.773-2.348 4.376-1.159 3.958-2.044 7.995-2.987 12.007-0.636 2.712 0.962 4.767 3.753 4.883 1.525 0.064 3.051 0.109 4.581 0.141 0.089 1.062 0.518 2.069 1.248 2.901 0.909 1.034 2.18 1.673 3.576 1.791 0.157 0.011 0.311 0.020 0.466 0.020 1.35 0 2.598-0.502 3.539-1.334 0.923-0.821 1.548-1.959 1.675-3.26 1.178 0.018 2.353 0.023 3.523-0.050 1.457-0.086 3.167-0.364 4.092-1.623 0.777-1.055 0.78-2.464 0.496-3.692-0.793-3.458-1.653-6.899-2.426-10.361zM13.464 30.006c-0.884-0.077-1.684-0.475-2.255-1.125-0.398-0.45-0.648-0.989-0.739-1.555 2.035 0.030 4.067 0.043 6.101 0.050 0.136 0 0.275 0 0.411 0.002-0.245 1.609-1.784 2.773-3.519 2.628zM23.057 24.708c-1.525 0-3.051-0.002-4.576-0.005-0.812 0-1.623-0.002-2.432-0.002-1.555-0.005-3.114-0.007-4.669-0.011-0.805-0.002-1.609-0.005-2.414-0.009-1.573-0.005-3.148-0.011-4.721-0.020-1.457-0.009-1.95-0.643-1.614-2.046 0.816-3.398 1.425-6.876 2.519-10.195 0.573-1.739 1.155-3.78 2.346-5.194 0.957-1.132 2.246-1.8 3.78-2.182 4.635-1.15 9.518 1.632 10.723 6.281 0.973 3.749 1.791 7.538 2.655 11.316 0.325 1.421-0.173 2.073-1.596 2.071z"
                              ></path>
                            </svg>
                          </div>
                          <a
                            href="javascript:"
                            class="font-medium truncate mr-5"
                          >
                            {{ notify.staff_user.first_name }}
                            {{ notify.staff_user.last_name }}
                          </a>
                          <div class="text-xs ml-auto whitespace-nowrap">
                            {{ $FormatDateMin(notify.sent_date) }}
                          </div>
                          <!-- <button
                          v-show="notify.state == 'New'"
                          type="button"
                          class="orange-btn-inverted flex ml-5"
                        >
                          {{ notify.state }}
                        </button> -->
                        </div>
                        <div class="w-full mt-0.5 pl-5">
                          {{ notify.message }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- END: Notifications -->
        </div>
      </div>

      <!-- Begin account Menu -->
      <!-- ACA -->

      <div
        v-if="!searchInput"
        class="profile_section flex flex-row gap-3 items-center px-2 sm:px-5"
      >
        <div class="hidden semixxs:flex semixxs:flex-col items-center">
          <h2
            class="nunito font-bold text-white text-sm lg:text-base whitespace-nowrap"
          >
            {{
              typeof user == 'object' && user
                ? user.name
                  ? user.name
                  : user.first_name + ' ' + user.last_name
                : user
            }}
          </h2>
          <!-- <div class="nunito text-white hidden md:block">-</div> -->
          <h2 class="nunito font-bold text-white text-xs lg:text-sm">
            ( {{ typeof user == 'object' && user ? user.role.name : '' }} )
          </h2>
        </div>

        <div class="dropdown ml-0 semixxl:ml-2 tooltipbuttonprofile">
          <span class="tooltipbuttontext">Profilo Utente</span>
          <div
            class="dropdown-toggle h-10 w-10 rounded-full overflow-hidden shadow-lg image-fit zoom-in"
            role="button"
            aria-expanded="false"
          >
            <svg id="icon-user_icon" viewBox="0 0 32 32">
              <path
                :fill="user.color || '#ff8f1c'"
                d="M32 16.004c0 2.773-0.719 5.499-2.078 7.896-1.258 2.218-3.046 4.116-5.186 5.514-0.102 0.063-0.195 0.133-0.297 0.195-0.351 0.219-0.719 0.43-1.086 0.617-0.109 0.055-0.219 0.109-0.328 0.164-2.171 1.062-4.593 1.625-7.022 1.625s-4.757-0.531-6.92-1.57c-0.109-0.055-0.219-0.109-0.328-0.164-0.359-0.18-0.719-0.383-1.062-0.594-0.102-0.063-0.203-0.125-0.305-0.195-2.171-1.39-3.991-3.296-5.272-5.53-1.382-2.413-2.117-5.163-2.117-7.959 0-4.272 1.664-8.295 4.686-11.318s7.045-4.686 11.318-4.686 8.295 1.664 11.318 4.686c3.023 3.023 4.686 7.037 4.686 11.318z"
              ></path>
              <path
                :fill="isLight ? '#3A3A3A' : '#FFFFFF'"
                d="M9.068 14.668c0.187 0.141 0.422 0.203 0.648 0.164 0.492-0.078 0.812-0.531 0.742-1.054-0.195-1.39-0.148-2.617 0.141-3.757 0.445-1.765 1.453-2.913 2.991-3.421 1.289-0.43 2.624-0.476 3.952-0.148 1.632 0.406 2.429 1.304 2.437 2.749 0 0.406 0.258 0.711 0.687 0.82 0.625 0.156 1.008 0.562 1.195 1.281 0.211 0.789 0.086 1.593-0.078 2.421-0.109 0.555 0.18 1.008 0.695 1.109 0.055 0.008 0.109 0.016 0.164 0.016 0.422 0 0.773-0.312 0.875-0.789 0.156-0.742 0.297-1.617 0.18-2.546-0.18-1.406-0.797-2.359-1.882-2.921-0.117-0.063-0.141-0.086-0.156-0.219-0.18-1.258-0.851-2.242-1.976-2.929-1.093-0.656-2.312-0.945-4.077-0.953h-0.016s-0.016 0-0.016 0c-0.070 0-0.164 0.016-0.273 0.023-0.305 0.023-0.719 0.055-1.133 0.133-2.242 0.391-3.843 1.578-4.749 3.515-0.797 1.695-1.015 3.569-0.687 5.905 0.031 0.234 0.156 0.445 0.351 0.594z"
              ></path>
              <path
                :fill="isLight ? '#3A3A3A' : '#FFFFFF'"
                d="M24.752 24.556c-0.023-0.18-0.055-0.359-0.102-0.531-0.117-0.5-0.312-0.937-0.57-1.304-0.687-0.961-1.773-1.398-3.015-1.835-0.375-0.133-0.75-0.266-1.125-0.398-0.023-0.008-0.047-0.016-0.063-0.023-0.094-0.039-0.227-0.086-0.359-0.117-0.016 0-0.023 0-0.031-0.008 0-0.008 0-0.031 0-0.055 0-0.156 0-0.305 0-0.453 0-0.195 0-0.375 0.008-0.555 0-0.070 0.055-0.164 0.086-0.195 0.906-0.758 1.5-1.687 1.765-2.749 0.25-1 0.211-2.007 0.18-2.984-0.008-0.32-0.023-0.648-0.023-0.961 0-0.476-0.461-0.804-0.89-0.82-0.266 0-0.539 0-0.758 0.016-0.992 0.055-1.875-0.031-2.718-0.242-1.156-0.297-1.96-0.75-2.546-1.422-0.367-0.422-0.719-0.492-0.945-0.476-0.219 0.016-0.547 0.133-0.828 0.578-0.43 0.672-0.922 1.187-1.523 1.578-0.344 0.226-0.515 0.555-0.515 0.976 0 0.258 0 0.523 0 0.781 0 0.484 0 0.984 0 1.476 0.031 1.382 0.492 2.593 1.375 3.616 0.086 0.102 0.18 0.195 0.273 0.281 0.164 0.164 0.32 0.312 0.383 0.469 0.055 0.148 0.039 0.359 0.023 0.586-0.008 0.148-0.023 0.297-0.016 0.453 0 0.063 0 0.086 0 0.102-0.008 0-0.031 0.023-0.094 0.039-0.734 0.219-1.515 0.469-2.538 0.812-1.351 0.453-2.242 1.351-2.64 2.671-0.102 0.336-0.156 0.695-0.164 1.031-0.016 0.922-0.008 1.859-0.008 2.765 0 0.359 0 0.711 0 1.070s0 0.555 0.016 0.773c0.102 0.063 0.203 0.133 0.305 0.195 0.344 0.211 0.703 0.406 1.062 0.594 0.109 0.055 0.219 0.109 0.328 0.164v-0.187c0-0.555 0-1.304-0.008-1.625 0-0.078 0-0.133 0-0.141 0-0.297 0-0.601 0-0.898 0-0.789 0-1.601 0-2.406 0-0.289 0.023-0.5 0.063-0.687 0.219-0.929 0.828-1.515 1.867-1.796 0 0.078 0 0.148 0 0.227 0 0.437 0 0.883 0 1.328-0.742 0.32-1.25 1.070-1.25 1.89s0.922 2.062 2.062 2.062 2.062-0.922 2.062-2.062-0.453-1.507-1.148-1.851c0-0.453 0-0.914 0-1.39 0.195 0.195 0.398 0.391 0.594 0.594 0.633 0.625 1.258 1.25 1.89 1.875 0.484 0.476 1.101 0.523 1.578 0.109 1.367-1.179 2.492-2.164 3.538-3.093 0.023 0 0.055 0.016 0.086 0.023 0.437 0.125 1.64 0.68 1.929 0.929 0.086 0.078 0.172 0.164 0.242 0.25 0.242 0.305 0.406 0.703 0.476 1.195 0.070 0.461 0.047 0.945 0.031 1.414-0.016 0.375-0.023 1.226-0.039 2.124-0.008 0.68-0.023 1.382-0.031 1.851v0.195c0.109-0.055 0.219-0.109 0.328-0.164 0.367-0.187 0.726-0.398 1.086-0.617 0.102-0.063 0.203-0.125 0.297-0.195 0-0.297 0.008-0.625 0.016-0.953 0.008-0.82 0.023-1.664 0.039-2.031 0.023-0.609 0.039-1.234-0.039-1.867zM11.825 26.54c-0.219 0-0.398-0.18-0.398-0.398s0.18-0.398 0.398-0.398 0.398 0.18 0.398 0.398-0.18 0.398-0.398 0.398zM18.042 22.151c-0.656 0.57-1.297 1.133-1.937 1.695l-0.562-0.57c-0.531-0.539-1.054-1.078-1.586-1.617 0.547-0.414 0.601-1.047 0.594-1.625 1.086 0.328 2.164 0.328 3.234 0 0.016 0.281 0.023 0.578 0.086 0.867 0.078 0.359 0.281 0.633 0.633 0.844l-0.461 0.406zM16.012 18.581c-1.437-0.016-2.812-1.062-3.273-2.484-0.148-0.469-0.195-1-0.234-1.5-0.031-0.453-0.023-0.914-0.008-1.367 0-0.117 0-0.242 0-0.359 0-0.016 0.008-0.047 0.016-0.055 0.109-0.102 0.226-0.203 0.344-0.305 0.148-0.125 0.297-0.25 0.437-0.391 0.18-0.172 0.336-0.367 0.492-0.547 0 0 0 0 0.008-0.008 1.882 1.507 4.069 1.75 6.022 1.734 0 0.234 0 0.469 0 0.695 0.016 0.789 0.031 1.531-0.242 2.249-0.555 1.468-1.921 2.367-3.585 2.343z"
              ></path>
            </svg>
          </div>
          <div class="dropdown-menu w-56">
            <div
              class="dropdown-menu__content text-white bg-theme-40 rounded-lg"
            >
              <div class="p-4 border-b border-theme-2">
                <div class="font-medium">
                  {{
                    typeof user == 'object' && user
                      ? user.name
                        ? user.name
                        : user.first_name + ' ' + user.last_name
                      : user
                  }}
                </div>

                <div class="text-xs text-theme-41 font-semibold mt-0.5">
                  {{ typeof user == 'object' && user ? user.role.name : '' }}
                </div>
              </div>
              <div
                class="p-2 transition duration-300 ease-in-out hover:bg-theme-41"
                @click="goToProfile()"
              >
                <span class="flex items-center block p-2 cursor-pointer">
                  <i class="fas fa-user mr-2"></i>
                  Profilo
                </span>
              </div>

              <div
                class="p-2 border-t border-theme-2 transition duration-300 ease-in-out hover:bg-theme-41"
              >
                <a
                  class="flex items-center block p-2 cursor-pointer"
                  @click="ChangeClinic"
                >
                  <i class="fas fa-edit mr-2" />
                  Cambia Clinica
                </a>
              </div>

              <div
                class="p-2 border-t border-theme-2 transition duration-300 ease-in-out hover:bg-theme-41"
              >
                <a
                  class="flex items-center block p-2 cursor-pointer"
                  @click="$store.dispatch('logout')"
                >
                  <i class="fas fa-power-off mr-2" />
                  Logout
                </a>
              </div>
              <div class="p-2 transition duration-300 ease-in-out">
                <span
                  v-if="version"
                  class="flex items-center block px-2 cursor-pointer"
                >
                  FE: {{ version }}
                </span>
                <span
                  v-if="version_be"
                  class="flex items-center block px-2 cursor-pointer"
                >
                  BE: {{ version_be }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- end account Menu -->
  </div>

  <!-- END: Top Bar -->
</template>

<script>
import { defineComponent, ref } from 'vue'
import { mapGetters, mapActions } from 'vuex'
// import DarkModeSwitcher from '@/components/dark-mode-switcher/Main.vue'

import RicercaAvanzata from '../../views/ricerca-avanzata/RicercaAvanzata.vue'
import Paginator from '../../components/paginator/Main.vue'

// import BreadCrumbs from '../../views/bread-crumbs/BreadCrumbs.vue'
import Toastify from 'toastify-js'
import router from '@/router'
import axios from '../../gateway/backend-api'
import NewClient from '../../views/nuovo-cliente/NewClient.vue'
import NewPet from '../../views/nuovo-pet/NewPet.vue'
import NewReferente from '../../views/nuovo-pet/NewReferente.vue'
import NotificationComponent from '../../components/notification/NotificationComponent.vue'

export default defineComponent({
  components: {
    // DarkModeSwitcher,
    NotificationComponent,
    RicercaAvanzata,
    // BreadCrumbs,
    NewClient,
    NewPet,
    NewReferente,
    Paginator
  },
  setup() {
    const version = process.env.VUE_APP_GIT_HASH
    const version_be = localStorage.getItem('beVersion')
    const clinic = localStorage.getItem('clinic-name')

    // const store = useStore()

    // const utente = computed(() => store.getters['getUser'])
    const searchDropdown = ref(false)

    const showSearchDropdown = () => {
      searchDropdown.value = true
    }

    const hideSearchDropdown = () => {
      searchDropdown.value = false
    }

    return {
      // viewportWidth,
      // isMobile,
      searchDropdown,
      showSearchDropdown,
      hideSearchDropdown,
      clinic,
      version,
      version_be
    }
  },

  data() {
    return {
      //Bell
      isMobile: false,
      viewporttSize: null,
      days: 1,
      notifications: [],
      searchInput: false,
      clientData: null,
      petData: null,
      dataToComplete: false,
      newReferent: false,
      newPet: false,
      newClient: false,
      searchBar: '',
      filteredPet: '',
      filteredCustomer: '',
      isActiveSearch: false,
      openModalAdvSearch: false,
      searchTicket: 0,
      notFinishedClient: '',
      totalRecordsCustomer: '',
      totalRecordsPet: '',
      pagination_customer: {
        page: 1,
        forPage: 5
      },
      pagination_pet: {
        page: 1,
        forPage: 5
      }
    }
  },

  computed: {
    ...mapGetters({
      getPetsDetails: 'anagraficaPazienti/getPetsDetails',
      getComparisonPets: 'anagraficaPazienti/getComparisonPets',
      getCustomersDetails: 'anagraficaClienti/getCustomersDetails',
      getComparisonCustomer: 'anagraficaClienti/getComparisonCustomer',
      user: 'getUser',
      permissions: 'reusableData/getPermissions',
      totalBell: 'reusableData/getTotalBell',
      profileColor: 'commonComponents/getProfileColor',
      isLight: 'commonComponents/getIsLight',
      clinicName: 'reusableData/getClinicName'
    }),
    reversedNotifications() {
      // Utiliza la función reverse() para invertir el orden de las notificaciones
      return this.notifications.slice().reverse()
    }
  },
  watch: {
    searchBar: function (elem) {
      if (elem == '') this.closeDropDownSearch()
    },
    totalBell: function () {
      console.log(this.totalBell)
    },
    profileColor: function () {
      if (this.profileColor) {
        this.user.color = this.profileColor
      }
    }
  },
  created() {
    console.log('this.isLight', this.isLight)
    console.log('profileColor', this.profileColor)
    this.checkWindowSize()
    // this.scrollToTop()
    window.addEventListener('resize', this.checkWindowSize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkWindowSize)
  },
  methods: {
    checkWindowSize() {
      this.isMobile = window.innerWidth < 900
    },

    ...mapActions({
      getPetAction: 'anagraficaPazienti/getPetAction',
      getSinglePetAction: 'anagraficaPazienti/getSinglePetAction',
      getCustomerAction: 'anagraficaClienti/getCustomerAction',
      getSingleCustomerAction: 'anagraficaClienti/getSingleCustomerAction',
      toggleModal() {
        this.openModalAdvSearch = !this.openModalAdvSearch
      },

      showSearch() {
        this.searchInput = !this.searchInput
      },

      openNewClient(dataClient, dataPet, es) {
        this.newClient = !this.newClient
        this.newPet = false
        if (es) {
          this.petData = es
        }
      },
      closeNewClientModal() {
        this.newClient = false
        this.clientData = null
        this.petData = null
      },
      closeNewPet() {
        this.newPet = false
        this.clientData = null
        this.petData = null
      },
      toggleConfirm() {
        this.toggleModal
        this.openConfirmDelete = !this.openConfirmDelete
      }
    }),

    getNotifications() {
      var vm = this

      axios
        .post('/' + localStorage.getItem('clinic') + '/notification', {
          // search: vm.search,
          // state: vm.state,
          // type: vm.type,
          days: vm.days
        })
        .then((res) => {
          vm.notifications = res.data

          Object.keys(vm.notifications).forEach(function (k) {
            if (vm.notifications[k].state == 'New')
              vm.toggleRead(vm.notifications[k].id)
          })
          vm.$store.dispatch('reusableData/getTotalBell')
        })
    },
    // Funzione che aggiorna al Backend lo status da New
    toggleRead: function (id) {
      // var vm = this

      axios
        .post('/' + localStorage.getItem('clinic') + '/notification/mark', {
          notification_id: id,
          state: 'Letta'
        })
        .then((res) => {
          console.log(res.data)
          // vm.notifications[index].state = state // Se le decommento il tag New non serve a nulla visivamente
        })
        .catch(function () {})
    },
    goToDashBoard: function () {
      router.push({ name: 'side-menu-dashboard' })
    },

    searchData: function (parameter) {
      console.log('parto')
      if (this.searchBar !== '') {
        this.$store.dispatch('commonComponents/showLoadingModalAction')
        axios
          .post('/' + localStorage.getItem('clinic') + '/search/globalSearch', {
            searchText: this.searchBar,
            filterParameter: parameter,
            ticket: ++this.searchTicket,
            per_page_customer: this.pagination_customer.forPage,
            page_customer: this.pagination_customer.page,
            per_page_pet: this.pagination_pet.forPage,
            page_pet: this.pagination_pet.page
          })
          .then((res) => {
            if (res.data.ticket == this.searchTicket) {
              this.filteredCustomer = res.data.customers.data.items
              this.totalRecordsCustomer = res.data.customers.total

              this.filteredPet = res.data.pet.data.items
              this.totalRecordsPet = res.data.pet.total
            }
            this.$store.dispatch('commonComponents/hideLoadingModalAction')
          })
      } else {
        this.filteredCustomer = ''
        this.filteredPet = ''
        this.totalRecordsCustomer = 0
        this.totalRecordsPet = 0
      }
    },
    dropDownSearch: function () {
      this.isActiveSearch = true
    },
    closeDropDownSearch: function () {
      this.isActiveSearch = false
    },
    // funzione che al click porta alla pagina profilo
    goToProfile: function () {
      router.push({ name: 'side-menu-profile' })
    },
    ChangeClinic: function () {
      this.$store.dispatch('commonComponents/openConfirmModal', {
        title: 'ATTENZIONE',
        subtitle:
          'Questa operazione potrebbe far perdere i dati non salvati. Sei sicuro di voler procedere?',
        background: false,
        confirm: () => {
          this.$store.dispatch('anagraficaClienti/clearCustomersAction')
          this.$store.dispatch('anagraficaPazienti/clearPetsAction')
          this.$store.dispatch('changeClinic')
        },
        decline: () => {}
      })
    },
    goToLogin: function () {
      router.push({ name: 'login' })
    },
    // goToSignup: function () {
    //   router.push({ name: 'register' })
    // },
    // funzione che fa apparire pop up quando superi il numero di tab aperte
    maxTabOpen: function () {
      Toastify({
        node: cash('#max-tab-open').clone().removeClass('hidden')[0],
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: 'top',
        position: 'right',
        stopOnFocus: true
      }).showToast()
    },
    // funzione che fa apparire pop-up quando provi ad aprire una tab già aperta
    tabAlreadyOpen: function () {
      Toastify({
        node: cash('#tab-already-open').clone().removeClass('hidden')[0],
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: 'top',
        position: 'right',
        stopOnFocus: true
      }).showToast()
    },
    longSearchNotification: function () {
      Toastify({
        node: cash('#notification-with-buttons-below-content')
          .clone()
          .removeClass('hidden')[0],
        duration: -1,
        newWindow: true,
        close: true,
        gravity: 'top',
        position: 'right',
        stopOnFocus: true
      }).showToast()
    },
    openPet(data, data2) {
      if (data != null && data2 === false) {
        this.clientData = data
      }
      if (data2 == false) {
        this.newClient = false
        this.newPet = true
      }
    },
    openReferente() {
      this.newReferent = !this.newReferent
    },
    changePaginationCustomer: function (value) {
      if (this.pagination_customer.page != value.page) {
        this.pagination_customer.page = value.page
        this.pagination_customer.forPage = value.forPage
        this.searchData()
      }
    },
    changePaginationPet: function (value) {
      if (this.pagination_pet.page != value.page) {
        this.pagination_pet.page = value.page
        this.pagination_pet.forPage = value.forPage
        this.searchData()
      }
    }
  }
})
</script>
